<template>
  <div id="assessment-form">
    <v-form :model="form" v-if="driver.driverId != ''">
      <div
        v-for="(item, index) in questions"
        :key="index">
        <v-card
          class="mx-auto my-12"
        >
          <v-card-text>
            <v-container fluid>
              <v-radio-group
                column
                v-model="form[index]"
              >
                <v-row>
                  <v-col>
                    <div>
                      <strong>{{index+1}} ) {{item.question}}</strong>
                    </div>
                  </v-col>
                  <v-spacer v-if="item.image"></v-spacer>
                  <v-col v-if="item.image">
                    <v-img
                      v-if="item.image"
                      :src="item.image.path"
                      :max-width="item.image.width"
                      height="100"
                    ></v-img>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-radio
                      v-for="a in item.answers"
                      :key="a[0]"
                      color="primary"
                      >
                      <template v-slot:label>
                        <div>{{a[0]}}</div>
                      </template>
                    </v-radio>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-container>
          </v-card-text>
        </v-card>
      </div>
    <v-row class="button-style">
      <v-btn
        color="primary"
        dark
        @click="validateAssessment"
      >
        Send
      </v-btn>
    </v-row>
  </v-form>
  </div>
</template>

<script>
import axios from 'axios';
import questionList from '../constants/questions';

export default {
  data() {
    return {
      form: {},
    };
  },
  methods: {
    validateAssessment() {
      for (let i = 0; i < this.questions.length; i += 1) {
        if (this.form[i] === undefined) {
          this.$notify({
            type: 'error',
            title: 'Warning',
            text: 'Please answer all questions.',
          });
          return;
        }
      }
      this.submit();
    },
    async submit() {
      const {
        assessmentId,
        driverId,
        pcoNumber,
        dvlaNumber,
      } = this.driver;
      const payload = {
        assessment_id: assessmentId,
        driver_id: driverId,
        pco_number: pcoNumber,
        dvla_number: dvlaNumber,
      };
      payload.answers = JSON.stringify(this.form);
      try {
        await axios.put(`${process.env.VUE_APP_ENV_VARIABLE}/theory-submit`, payload);
        this.$notify({
          type: 'success',
          title: 'Success',
          text: 'The assessment has been successfully submitted.',
          duration: 10000,
        });
        this.$root.$emit('clearForm');
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Warning',
          text: 'Error submitting the assessment',
          duration: 10000,
        });
      }
    },
    resetStore() {
      this.$store.dispatch('theory/resetStore');
    },
  },
  beforeDestroy() {
    this.resetStore();
  },
  computed: {
    questions() {
      return questionList.questions;
    },
    driver() {
      return this.$store.getters['theory/getDriver'];
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 760px){
  #assessment-form{
    margin-top: 20%;
  }
}
@media screen and (min-width: 760px){
  #assessment-form{
    margin-top: 10%;
  }
}
.v-sheet.v-card {
  border-radius: 12px;
}
.spacer {
  flex-grow: .2 !important;
}
.button-style {
  float: right;
  padding: 0 2em 2em 0;
}
.vue-notification {
  font-size: 16px
}
</style>
